/* eslint-disable */
// THIS FILE WAS GENERATED BY TRANSLATIONS-CLI ON Thu Apr 30 2020 19:30:13 GMT+0100 (Western European Summer Time) 
// DO NOT MODIFY DIRECTLY.
 
export default {
  'en-AU': require('./en-AU.js').default,
  'zh-CN': require('./zh-CN.js').default,
  'zh-TW': require('./zh-TW.js').default,
};